import { render, staticRenderFns } from "./Addthemesize.vue?vue&type=template&id=5cdd5e00&scoped=true"
import script from "./Addthemesize.vue?vue&type=script&lang=js"
export * from "./Addthemesize.vue?vue&type=script&lang=js"
import style0 from "./Addthemesize.vue?vue&type=style&index=0&id=5cdd5e00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdd5e00",
  null
  
)

export default component.exports